import React from 'react'

const Manual_creacion_de_grupos_y_unidades_de_cobro = () => {
  return (
    <>
       {/* Nuevo manual de uso: Yappy - Creación de Grupos y Unidades de cobro */}
       <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
       <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Yappy - Creación de Grupos y Unidades de cobro
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica de forma sencilla cómo crear un punto de pago con Yappy,
          facilitando la gestión de cobros para negocios. Proporciona instrucciones claras
          para configurar grupos y unidades de pago, optimizando el procesamiento de
          transacciones y la organización financiera.
        </p>
        <iframe
          src="https://scribehow.com/embed/Yappy__Creacion_de_Grupos_y_Unidades_de_cobro__rcmGhzuGRECzXn8plvrAnQ?as=scrollable"
          className="scribe-iframe-yappy-1"
          width="100%"
          height="4900"
          allowFullScreen
          style={{
            border: 0,
            overflow: 'hidden',
          }}
        ></iframe>
      </div>
      </div>
    </>
  )
}

export default Manual_creacion_de_grupos_y_unidades_de_cobro


